import React, {useEffect, useState} from 'react';
import {useFormikContext} from 'formik';
import {FormattedMessage, useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import {calcLineTotals, formatMonetaryAmount} from '../../../../common/utils';
import {OrderInvoiceFormValues} from '../../types';
import {LineTotals} from '../../../../common/types';
import {VAT} from '../../../../services';
import currency from '../../../../common/assets/icons/shekel-sign.svg';
import styles from './LinesTotalWidget.module.scss';
import {useOrderInvoiceFormContext} from "../../contexts/OrderInvoiceFormContext";

const defaultTotals = {
  total: 0,
  totalVAT: 0,
  VAT: 0
};

const LinesTotalWidget = () => {
  const [totals, setTotals] = useState<LineTotals>(defaultTotals);
  const {values, touched, errors} = useFormikContext<OrderInvoiceFormValues>();
  const {showAllErrors} = useOrderInvoiceFormContext();

  useEffect(() => {
    setTotals(calcLineTotals(values, new Date()));
  }, [values]);

  const intl = useIntl();
  const labelTotal = intl.formatMessage({
    id: 'orderInvoice-page-total',
    defaultMessage: 'Total'
  });
  const labelVat = intl.formatMessage({
    id: 'orderInvoice-page-vat',
    defaultMessage: ' VAT',
  });
  const fullLabelVat = `${labelVat} ${VAT.toString()}`;
  const labelTotalVat = intl.formatMessage({
    id: 'orderInvoice-page-totalVat',
    defaultMessage: 'Total with VAT',
  });
  const totalAmountErrorMessage = intl.formatMessage({
    id: 'orderInvoice-total-amount-error-message',
    defaultMessage: 'Total can\'t be 0',
  });

  return (
    <div className={styles.container}>
      <div className={styles.value}>
        <div className={styles.labelMobile}>{labelTotal}</div>
        <InputText
          id={'total'}
          variant={'full'}
          value={formatMonetaryAmount(totals.total, false)}
          disabled={true}
          label={(
            <FormattedMessage
              id={'orderInvoice-page-total'}
              defaultMessage={'Total'}
            />
          )}
          customClassnames={{container: styles.customPadding}}
        />
        <img src={currency} alt="currency" className={styles.currencyIcon}/>
      </div>
      <div className={styles.value}>
        <div className={styles.labelMobile}>{fullLabelVat}</div>
        <InputText
          id={'VAT'}
          variant={'full'}
          value={formatMonetaryAmount(totals.VAT, false)}
          disabled={true}
          label={(
            <FormattedMessage
              id={'orderInvoice-page-vat'}
              defaultMessage={'{vat}% VAT'}
              values={{vat: VAT.percents()}}
            />
          )}
          customClassnames={{container: styles.customPadding}}
        />
        <img src={currency} alt="currency" className={styles.currencyIcon}/>
      </div>
      <div className={styles.value}>
        <div className={styles.labelMobile}>{labelTotalVat}</div>
        <InputText
          id={'totalVat'}
          variant={'full'}
          value={formatMonetaryAmount(totals.totalVAT, false)}
          disabled={true}
          label={(
            <FormattedMessage
              id={'orderInvoice-page-totalVat'}
              defaultMessage={'Total with VAT'}
            />
          )}
          customClassnames={{container: styles.customPadding}}
          showErrorOnSubmit={showAllErrors}
        />
        <img src={currency} alt="currency" className={styles.currencyIcon}/>
        {Boolean(touched?.lines) && Boolean(errors?.totalAmount) && (
          <div className={styles.errorContainer}>{totalAmountErrorMessage}</div>
        )}
      </div>
    </div>
  );
};

export default LinesTotalWidget;
